import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/tickets/`;

// Create new ticket
const createTicket = async (ticketData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.post(API_URL, ticketData, config);
  return response.data;
};

// Get user tickets
const getTickets = async (token, { page = 1, isClosedTickets = false }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(
    `${API_URL}?page=${page}&isclosedtickets=${isClosedTickets}`,
    config
  );

  return response.data;
};

// Get user ticket
const getTicket = async (ticketId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL + ticketId, config);

  return response.data;
};

// StartOrClose ticket
const startOrCloseTicket = async (value, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.put(
    API_URL + value?.ticketId,
    { status: value?.status },
    config
  );

  return response.data;
};

const ticketService = {
  createTicket,
  getTickets,
  getTicket,
  startOrCloseTicket,
};

export default ticketService;
